module.exports = __webpack_public_path__ + "img/bz4@2x.de22e907.png";